import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/short-tour6.jpg";
import Newsletter from "../../shared/Newsletter";

const Ranthambore = () => {
  return (
    <>
      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">
          Ranthambore
        </h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Bakaula</li>
                      <li>LakardaAnantpura</li>
                      <li>Ranthambore Fort</li>
                      <li>Kachida Valley</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Ranthambore
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    One of the leading national parks in Northern India,
                    Ranthambore is famous for its tigers and it is the solitary
                    place in India where these royal predators can be spotted in
                    the jungle, even during the day. The park is home to a huge
                    tiger population. Other wild animals that can be spotted in
                    the park include the leopard, nilgai, dhole, wild boar,
                    sambar, hyena, sloth bear and chital. Moreover, Ranthambore
                    also has a vast range of plants, trees, reptiles and birds.
                  </p>
                  <p>
                    The park covers an area of Approximately 400 sq Km and if
                    combined it with the area of sawai man singh sanctuary
                    area,it is around 500 Sq km. Ranthambore is also reckoned as
                    the famous heritage site because of the pictorial ruins that
                    dot the wildlife park. Certainly, a visit to Ranthambore
                    National Park is anindulgence for every wildlife and nature
                    lover. The time spend on watching tigers roaming around,
                    verdant greenery, anarray of other species of chirpy birds
                    and animals is priceless and worth enough to be explored at
                    least once in a life
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Bakaula
                  </h2>

                  <p>
                    Bakaula is the thickly forested regions in Ranthambore
                    National Park. It consists of dense forest, with many small
                    pools and water holes in clearings in the vegetation.
                    Because of the tremendous forest cover and availability of
                    water, the Bakaula region in National Park Ranthambore has
                    plenty of wildlife. Tigresses with young cubs are often seen
                    near the water holes in Bakaula, since the thick forest
                    provides cool hides for a tigress and her youngones. The
                    dense vegetation also retains moisture in the air and lowers
                    the temperature of this area. Bakaula is one of the coolest
                    regions of National Park Ranthambore, where many birds can
                    be seen in the trees and small animals like squirrels and
                    monkeys scuttle through the forest.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    LakardaAnantpura
                  </h2>
                  <p>
                    A must to visit locations if looking for Sloth Bears and are
                    situated in the North-Western and Northern regions of the
                    park.These areas have a lot of ant hills, which are a
                    favourite of the beers. Although very rarely seen
                    themselves, the pugmarks of the Indian striped Hyenas are
                    often seen here. Their numbers are not very large in the
                    park.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Ranthambore Fort
                  </h2>
                  <p>
                    The fort stands grandly on top of a hill overlooking the
                    entire park. The view of the surrounding get better and
                    better as you go up but the view from the fort itself can
                    only be described as stunning. It is advisable to take along
                    a good pair of binoculars and if possible a camera with a
                    very powerful lens when visiting the fort. The spiraling
                    Serpent, eagles, vultures and other birds can be seen at eye
                    level. Many animals can also be seen along the edges of all
                    the water bodies. The fort itself also offers many
                    interesting architectural and historical sights worth
                    viewing and photographing. A trip to the fort is a must if
                    you are a first time visitor to the park.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Kachida Valley
                  </h2>
                  <p>
                    The valley consists of many rocky outcrops and low hills, is
                    located close to the suburbs of the park. A jeep would be
                    the ideal mode of transport when trying to visit this area.
                    The valley holds a majority of the Panther population of the
                    park. The panthers avoid venturing into the main jungle to
                    avoid encounters with tigers, who are known to kill them.
                    This area also has a decent population of bears.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Nahargarh Fort
                  </h2>
                  <p>
                    Perched atop a picturesque hill, the Nahargarh Fort offers a
                    breathtaking view of the city below. Initially built by
                    Sawai Jain Singh in 1734 A.D. It was enlarged and given its
                    present shape by Sawai Madho Singh in 1885 A.D. Decorative
                    motifs in some of the rooms are delightful. From the windows
                    of the nine identical suites, one gets a magnificent view of
                    the city, complete with the geometrical layout. From Amer
                    there is a road to Nahargarh, which passes through the
                    hills.
                  </p>
                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Ranthambore;
